export default {
    title: 'Insider',
    subtitle: 'These people are well versed in this topic',
    button: {
        add: 'Become an insider',
        remove: 'Remove insider status'
    },
    list: {
        empty: 'There are currently no insiders on this topic.',
        filled: 'These people are well versed in this topic.'
    }
}
